/**
 * @generated SignedSource<<86e3fd4f4efb533cd0d8c2c8570340ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StatsPanel_viewer$data = {
  readonly user: {
    readonly isGuest: boolean;
  };
  readonly " $fragmentType": "StatsPanel_viewer";
};
export type StatsPanel_viewer$key = {
  readonly " $data"?: StatsPanel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"StatsPanel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StatsPanel_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isGuest",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b8f5e083c0dfe822d541848f8ab65590";

export default node;
